import { environment } from "../../environments/environment.local";

export class ApiPaths {
  static readonly LOGIN_URL = environment.BASE_API + '/api/auth/login';
  static readonly VERIFY_USER_URL = environment.BASE_API + '/api/auth/validate';
  static readonly INVALIDATE_TOKENS_URL = environment.BASE_API + '/api/auth/logout';
  static readonly REGISTRATION_URL = environment.BASE_API + '/api/user/register';
  static readonly EMAIL_VERIFICATION_URL = environment.BASE_API + '/api/auth/verify-email';
  static readonly PROMOTE_TO_ADMIN_URL = environment.BASE_API + '/api/user/admin';
}